/**
* Created For: 主页面
* Author: chenLiYan.
* Date: 2018/11/29 0029 15:49.
*/
<template>

  <div
    ref="pageWrap"
    class="home-page flex-wrap flex-vertical"
    @click="isShowPop = false"
  >
    <!--头部状态栏-->
    <div class="status-wrap flex-none">
      <i @click="back" class="cubeic-back" v-if="permissionsInfo.length > 1"></i>
      <!--头部搜索-->
      <div class="client-filter" @click="$refs.clientFilter.show()">
        <search-bar
          placeholder="搜索终端名称"
          :defaultVal="curClientName"
          :isShowClose="false"
        ></search-bar>
        <span
          v-if="curClientName"
          class="sprite icon-close"
          @click.stop="
            curClientName = '';
            clientFilterHandle('');
          "
        ></span>
      </div>
      <div class="user-box">
        <span class="sprite icon-user" @click.stop="userPopHandle"></span>
        <!--展开-->
        <div class="expand-box" v-if="isShowPop">
          <ul>
            <!-- <li class="flex-wrap" @click="$router.push({ name:'updatePassword' })"> -->
            <li class="flex-wrap" @click="goresetPwd()">
              <span class="sprite icon-lock"></span>
              <span>修改密码</span>
            </li>
            <li class="flex-wrap" @click="loginOutHandle()">
              <span class="sprite icon-login-out"></span>
              <span>退出登录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--筛选横栏-->
    <div class="filter-bar flex-wrap flex-none">
      <v-area
        ref="areaPicker"
        :defaultAreaName="defaultAreaName"
        @areaChange="areaPickerHandle"
        @cancel="pushUserLog('地区选择-取消')"
        @pickerClick="pushUserLog('地区选择')"
      ></v-area>
      <div
        class="filter-tip"
        @click="
          $refs.VFilter.show();
          pushUserLog('打开筛选条件浮层');
        "
      >
        <span class="sprite icon-filter-blue"></span>
      </div>
    </div>
    <!--终端名称筛选-->
    <client-filter
      ref="clientFilter"
      :clientName="curClientName"
      @searchHandle="clientFilterHandle"
    ></client-filter>
    <!--筛选侧滑-->
    <v-filter
      ref="VFilter"
      :params="filterParams"
      @filterHandle="filterHandle"
      @cancel="pushUserLog('筛选条件浮层-取消')"
    ></v-filter>
    <!--地图与列表主体区域-->
    <div ref="content" class="content-wrap flex-wrap flex-vertical flex-auto">
      <!--地图区域-->
      <div
        ref="mapBox"
        :class="[
          'map-container',
          !isMapAuto ? 'flex-none limit-h' : '',
          touchObj.isTouchMove ? 'z-low' : '',
        ]"
        :style="mapStyle"
      >
        <v-map
          ref="vMap"
          :markerList="markerList"
          @moveStart="isShowPop = false"
          @getDistrictCenter="getDistrictCenterHandle"
          @positionAreaName="positionAreaHandle"
          @getMyPosition="getMyPositionHandle"
          @viewDetails="getClientDetails"
          @positionEnd="positionHandle"
          @positionError="pushUserLog('定位-失败')"
        >
        </v-map>
      </div>
      <!--显示终端详细信息-->
      <div class="detail-box flex-none" v-if="curClientDetails.matchClientId">
        <div class="detail-content">
          <div class="title-box">
            <p class="title">{{ curClientDetails.clientName }}</p>
            <span
              class="close-box"
              @click="hideDetails()"
            ><span class="sprite icon-close-black"></span
            ></span>
          </div>
          <div style="overflow: hidden">
            <div class="address-p">
              {{ curClientDetails.clientAddress }}
            </div>
            <div
              class="address-right"
              @click="feedbackMessage(curClientDetails)"
            >
              反馈
            </div>
          </div>

          <div class="bussiness-p">
            <span
            >经营状态：
              {{
                curClientDetails.businessStatus !== ""
                  ? curClientDetails.businessStatus
                  : "暂无"
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
            <span
            >税收状态：{{
              curClientDetails.taxStatus !== ""
                ? curClientDetails.taxStatus
                : "暂无"
            }}</span
            >
          </div>
          <div class="type-box">
            <button
              type="button"
              class="cover-btn covered"
              v-if="curClientDetails.cover"
            >
              已覆盖
            </button>
            <button type="button" class="cover-btn un-cover" v-else>
              未覆盖
            </button>
            <button type="button" class="client-type">
              {{ curClientDetails.thirdTypeName }}
            </button>
            <!--  <button type="button" class="client-type">{{ $store.state.clientType[curClientDetails.thirdType] }}</button> -->
            <button
              class="go-purchaseDetail"
              v-show="curClientDetails.cover"
              @click="goPurchaseDetail(curClientDetails)"
            >
              购进详情
            </button>
          </div>
        </div>
        <div class="navigation-box flex-wrap">
          <a
            @click="pushUserLog('点击电话号码')"
            v-if="curClientDetails.phone"
            :href="`tel:${curClientDetails.phone}`"
            class="btn-item flex-wrap link-box"
          ><span class="sprite icon-phone"></span
          ><span style="width: fit-content">{{
            curClientDetails.phone
          }}</span></a
          >
          <button v-else="" type="button" disabled class="btn-item no-phone">
            暂无联系方式
          </button>
          <button
            type="button"
            class="btn-item navigation"
            @click="showActionSheet(curClientDetails)"
          >
            开始导航
          </button>
        </div>
      </div>
      <div
        class="touch-panel"
        v-show="!curClientDetails.matchClientId && clientPageList.length > 0"
      >
        <cube-scroll
          ref="panelScroll"
          :data="clientPageList"
          :options="panelScrollOptions"
          :scroll-events="['before-scroll-start', 'scroll', 'scroll-end']"
          @before-scroll-start="beforeScrollHandle"
          @scroll="parentScroll"
          @scroll-end="scrollEndHandle"
        >
          <!--占位-->
          <div
            class="placeholder"
            :style="{ height: touchObj.placeholderHeight + 'px' }"
          ></div>
          <!--客户终端文字列表-->
          <div
            ref="listBox"
            class="client-list-wrap flex-wrap flex-vertical"
            :style="{ height: touchObj.listHeight + 'px' }"
          >
            <div
              v-if="!touchObj.isShowMoreTip"
              ref="handle"
              class="handle flex-wrap flex-v-center flex-none"
            >
              <span></span>
            </div>
            <!--点击查看更多-->
            <div
              v-else=""
              class="view-more-tip flex-none"
              @click="viewMoreHandle"
            >
              点击查看更多
            </div>
            <div class="list-box">
              <cube-scroll
                ref="scroll"
                :data="clientPageList"
                :options="scrollOptions"
                class="noMinHeight"
                @pulling-up="onPullingUp"
                nest-mode="free"
                :scroll-events="[
                  'before-scroll-start',
                  'scroll',
                  'scroll-end',
                ]"
                @scroll="scrollHandler"
                @scroll-end="listScrollEnd"
                @before-scroll-start="listScrollStart"
              >
                <ul ref="listUl">
                  <li
                    v-for="(item, index) in clientPageList"
                    @click="viewDetails(item, index)"
                    :key="index"
                  >
                    <div class="li-p">
                      <p class="title">
                        {{ index + 1 + "." + item.clientName }}
                      </p>
                      <button
                        type="button"
                        class="cover-btn covered"
                        v-if="item.cover"
                      >
                        已覆盖
                      </button>
                      <button type="button" class="cover-btn un-cover" v-else>
                        未覆盖
                      </button>
                    </div>
                    <div class="li-p address">
                      <p>{{ item.clientAddress }}</p>
                      <!-- <span class="type">{{ $store.state.clientType[item.thirdType] }}</span> -->
                      <span class="type">{{ item.thirdTypeName }}</span>
                    </div>
                    <div class="li-p address">
                      <span
                      >经营状态：{{
                        item.businessStatus !== ""
                          ? item.businessStatus
                          : "暂无"
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                      >
                      <span
                      >税收状态：{{
                        item.taxStatus !== "" ? item.taxStatus : "暂无"
                      }}</span
                      >
                    </div>
                  </li>
                </ul>
                <!--自定义上拉加载更多-->
                <template slot="pullup" slot-scope="props">
                  <div
                    class="cube-pullup-wrapper custom-pull-up"
                    v-if="props.pullUpLoad"
                  >
                    <template v-if="props.isPullUpLoad">
                      <span class="pull-up-loading"></span>
                      <span>正在加载请稍后</span>
                    </template>
                    <template v-else-if="listScrollY === 0">
                      <span>{{ props.pullUpLoad.txt.noMore }}</span>
                    </template>
                    <template v-else="">
                      <span
                        v-if="
                          filterParams.page * filterParams.limit >= totalCount
                        "
                      >{{ props.pullUpLoad.txt.noMore }}</span
                      >
                      <span v-else>{{ props.pullUpLoad.txt.more }}</span>
                    </template>
                  </div>
                </template>
              </cube-scroll>
            </div>
          </div>
        </cube-scroll>
      </div>
    </div>
    <!--加载中-->
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
    <!--高德地图路线规划-->
    <v-map-driving
      ref="mapDriving"
      :myPosition="myPositionCenter"
      :destination="curClientDetails"
      @backHandle="pushUserLog('路线导航-返回')"
    ></v-map-driving>
  </div>

</template>

<script>
import { asyncLoginOut } from '@/api/auth'
import { isWeiXin } from '@/utils/utils'
import {
  asyncSearchClientPage,
  asyncSearchClientMarker,
  asyncGetMaxTime
} from '@/api/clientSearch'
import { getXhDepartmentAnalyse } from '@/api/common'
import SearchBar from './_search_bar.vue'
import VArea from '@/components/AreaPicker.vue'
import ClientFilter from './_client_filter.vue'
import VFilter from './_filter.vue'
import VMap from '@/components/VMap.vue'
import VMapDriving from '@/components/VMapDriving.vue'
import CustomLoading from '../../components/CustomLoading.vue'
import { mapGetters } from 'vuex'
import { get } from 'lodash'
export default {
  name: 'Home',
  components: {
    CustomLoading,
    SearchBar,
    VArea,
    ClientFilter,
    VFilter,
    VMap,
    VMapDriving // 高德地图路线规划组件
  },
  props: {},
  data () {
    return {
      loading: false, // 是否加载中
      paging: false, // 是否正在翻页中，避免一次加载两页
      isShowPop: false, // 是否显示用户pop
      curClientName: '', // 默认客户终端名
      // 搜索参数
      filterParams: {
        page: 1,
        limit: 10,
        isCoveredAbnormal: false,
        clientType: '', // 终端类型 默认全部
        // 原界定超过27号取上个月（现通过后台接口控制）
        startTime:
          this.$dayjs().date() > 27
            ? this.$dayjs(new Date(this.$dayjs().subtract(1, 'month')))
              .startOf('month')
              .valueOf()
            : this.$dayjs(new Date(this.$dayjs().subtract(2, 'month')))
              .startOf('month')
              .valueOf(),
        endTime:
          this.$dayjs().date() > 27
            ? this.$dayjs().startOf('month').valueOf()
            : this.$dayjs(new Date(this.$dayjs().subtract(1, 'month')))
              .startOf('month')
              .valueOf(),
        lat: undefined,
        lng: undefined,
        org: undefined
      },
      // 默认月份
      defaultMonth: {
        startTime:
          this.$dayjs().date() > 27
            ? this.$dayjs(new Date(this.$dayjs().subtract(1, 'month')))
              .startOf('month')
              .valueOf()
            : this.$dayjs(new Date(this.$dayjs().subtract(2, 'month')))
              .startOf('month')
              .valueOf(),
        endTime:
          this.$dayjs().date() > 27
            ? this.$dayjs().startOf('month').valueOf()
            : this.$dayjs(new Date(this.$dayjs().subtract(1, 'month')))
              .startOf('month')
              .valueOf()
      },
      // 分页数据
      totalCount: 0, // 总条数
      covered: 0, // 已覆盖条数,暂未用到
      notCover: 0, // 未覆盖条数,暂未用到
      markerList: [], // 标记点列表
      clientPageList: [], // 客户终端具体信息分页列表
      // scroll滚动相关参数
      scrollOptions: {
        bounce: {
          top: false,
          bottom: true,
          left: false,
          right: false
        },
        pullUpLoad: {
          threshold: 0,
          txt: {
            more: '上拉加载更多',
            noMore: '没有更多结果了'
          }
        }
      },
      panelScrollOptions: {
        bounce: {
          top: false,
          bottom: false,
          left: false,
          right: false
        }
      },
      // 默认地址名称
      defaultAreaName: {},
      curClientDetails: {}, // 当前终端详情数据
      // 拖动交互相关变量
      touchObj: {
        isTouchMove: false, // 是否正在滚动
        isScrollTo: false, // 是否正在执行scrollTo
        isScrolling: false, // 是否正在滚动列表，用于防止滚动时触发点击
        // 列表高度，渲染完后为整个内容区域高度
        listHeight: 300,
        // 占位符高度
        placeholderHeight: Math.round(562 * this.$store.state.per),
        // 阈值高度
        threshold: Math.round(562 * this.$store.state.per),
        // 滑动时当前地图区域高度
        curMapStyle: {
          height: Math.round(562 * this.$store.state.per) + 'px'
        },
        // 是否显示点击查看更多
        isShowMoreTip: false
      },
      listScrollY: 0, // 列表区域当前滚动的y轴距离
      // 我的位置坐标 定位失败时，弹窗提示
      myPositionCenter: ''
    }
  },
  computed: {
    ...mapGetters(['permissionsInfo']),
    // 地图区域是否自动高度
    isMapAuto () {
      return (
        !!this.curClientDetails.matchClientId ||
        this.clientPageList.length === 0
      )
    },
    mapStyle () {
      // 查看详情时，去掉style样式，采用自动高度
      if (this.isMapAuto) {
        return {}
      } else {
        return this.touchObj.curMapStyle
      }
    },
    // 滚动的差值
    touchLess () {
      return this.touchObj.threshold - this.touchObj.placeholderHeight
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.VFilter && this.$refs.VFilter.isShow) {
      this.$refs.VFilter.hide()
      next(false)
    } else if (this.$refs.clientFilter && this.$refs.clientFilter.isShow) {
      this.$refs.clientFilter.hide()
      next(false)
    } else if (
      this.$refs.areaPicker &&
      this.$refs.areaPicker.areaPicker &&
      this.$refs.areaPicker.areaPicker.isVisible
    ) {
      // 关闭地区选择
      this.$refs.areaPicker.areaPicker.hide()
      next(false)
    } else if (this.curClientDetails.matchClientId) {
      // 关闭显示详情
      // this.$refs.vMap.curActivePoint = {};
      // this.curClientDetails = {};
      next()
    } else if (this.$refs.mapDriving && this.$refs.mapDriving.isShow) {
      // 关闭地图路线规划
      this.$refs.mapDriving.hide()
      next(false)
    } else {
      next()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.touchObj.listHeight = Math.ceil(this.$refs.content.offsetHeight) + 1
      this.touchObj.placeholderHeight = Math.floor(
        this.$refs.content.offsetHeight - (88 + 24) * this.$store.state.per
      )
      // 为兼容微信，微信mounted获取的还是未处理iphoneX safe-area-inset-bottom的高度
      const _this = this
      setTimeout(function () {
        _this.touchObj.placeholderHeight = Math.floor(
          _this.$refs.content.offsetHeight - (88 + 24) * _this.$store.state.per
        )
      }, 2000)
    })
    // 获取最新统计数据月份
    asyncGetMaxTime({ dataType: 'all', flowType: 'S' })
      .then((res) => {
        if (res.code === 1) {
          this.defaultMonth.startTime = this.$dayjs()
            .set('year', res.data.maxYear)
            .set('month', parseInt(res.data.maxMonth) - 1)
            .subtract(5, 'month')
            .startOf('month')
            .valueOf()
          if (
            this.defaultMonth.startTime <
            this.$dayjs()
              .set('year', res.data.minYear)
              .set('month', parseInt(res.data.minMonth) - 1)
              .startOf('month')
              .valueOf()
          ) {
            this.defaultMonth.startTime = this.$dayjs()
              .set('year', res.data.minYear)
              .set('month', parseInt(res.data.minMonth) - 1)
              .startOf('month')
              .valueOf()
          }
          this.defaultMonth.endTime = this.$dayjs()
            .set('year', res.data.maxYear)
            .set('month', parseInt(res.data.maxMonth) - 1)
            .endOf('month')
            .valueOf()
        }
        this.filterParams.startTime = this.defaultMonth.startTime
        this.filterParams.endTime = this.defaultMonth.endTime
        this.filterParams.minMonthTime = this.$dayjs()
          .set('year', res.data.minYear)
          .set('month', parseInt(res.data.minMonth) - 1)
          .startOf('month')
          .valueOf()
        this.filterParams.maxMonthTime = this.defaultMonth.endTime
      })
      .catch(() => {})
    // 获取部门
    getXhDepartmentAnalyse().then(res => {
      if (res.code === 1) {
        this.filterParams.org = get(res, 'data.detail', []).map(i => i.departmentId).join(',')
      }
    })
      .catch(() => {
        console.log('获取部门失败')
      })
  },
  activated () {
    console.log(this.$route.meta.keepAlive)
    if (this.$route.meta.keepAlive === false) {
      this.$nextTick(() => {
        this.touchObj.listHeight =
          Math.ceil(this.$refs.content.offsetHeight) + 1
        this.touchObj.placeholderHeight = Math.floor(
          this.$refs.content.offsetHeight - (88 + 24) * this.$store.state.per
        )
        // 为兼容微信，微信mounted获取的还是未处理iphoneX safe-area-inset-bottom的高度
        const _this = this
        setTimeout(function () {
          _this.touchObj.placeholderHeight = Math.floor(
            _this.$refs.content.offsetHeight -
              (88 + 24) * _this.$store.state.per
          )
        }, 2000)
      })
      // 获取最新统计数据月份
      asyncGetMaxTime({ dataType: 'all', flowType: 'S' })
        .then((res) => {
          if (res.code === 1) {
            this.defaultMonth.startTime = this.$dayjs()
              .set('year', res.data.maxYear)
              .set('month', parseInt(res.data.maxMonth) - 1)
              .subtract(5, 'month')
              .startOf('month')
              .valueOf()
            if (
              this.defaultMonth.startTime <
              this.$dayjs()
                .set('year', res.data.minYear)
                .set('month', parseInt(res.data.minMonth) - 1)
                .startOf('month')
                .valueOf()
            ) {
              this.defaultMonth.startTime = this.$dayjs()
                .set('year', res.data.minYear)
                .set('month', parseInt(res.data.minMonth) - 1)
                .startOf('month')
                .valueOf()
            }
            this.defaultMonth.endTime = this.$dayjs()
              .set('year', res.data.maxYear)
              .set('month', parseInt(res.data.maxMonth) - 1)
              .endOf('month')
              .valueOf()
          }
          this.filterParams.startTime = this.defaultMonth.startTime
          this.filterParams.endTime = this.defaultMonth.endTime
          this.filterParams.minMonthTime = this.$dayjs()
            .set('year', res.data.minYear)
            .set('month', parseInt(res.data.minMonth) - 1)
            .startOf('month')
            .valueOf()
          this.filterParams.maxMonthTime = this.defaultMonth.endTime
        })
        .catch(() => {})
    }
  },
  methods: {
    back () {
      this.$router.push({ name: 'index' })
    },
    // 重置数据
    resetData () {
      // 重置除地址外的其他参数
      this.filterParams.clientType = '10101'
      this.filterParams.cover = ''
      this.filterParams.drugName = ''
      this.filterParams.spec = ''
      this.filterParams.startTime = this.defaultMonth.startTime
      this.filterParams.endTime = this.defaultMonth.endTime
      this.totalCount = 0
      this.lat = undefined
      this.lng = undefined
    },
    // 获取终端数据
    searchClient (isPosition) {
      if (
        !this.filterParams.provinceCode &&
        !this.filterParams.cityCode &&
        !this.filterParams.districtCode
      ) {
        // 提示选择地区
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: '请选择地区！'
        }).show()
        return
      }
      this.loading = true
      Promise.all([
        asyncSearchClientPage(this.filterParams),
        asyncSearchClientMarker(this.filterParams)
      ])
        .then(([clientPageRes, clientMarkerRes, clientGetOrg]) => {
          if (clientPageRes.code === 1 && clientMarkerRes.code === 1) {
            const pageItems = clientPageRes.data.items || []
            // let pageItems = [{
            //     clientAddress: "北京市东城区东四南大街157号-6",
            //     clientName: "叮当智慧药房(北京)有限公司第一店",
            //     clientSubType: null,
            //     clientType: null,
            //     cover: false,
            //     matchClientId: "O674ca8d2d821012",
            //     thirdType: 10102,
            // }]
            const { covered, scaClientMapRespList, notCover } =
              clientMarkerRes.data
            this.covered = covered || 0
            this.notCover = notCover || 0
            this.markerList = scaClientMapRespList || []
            // this.markerList =[{
            //     boundary: [],
            //     boundaryTags: [],
            //     businessStatus: "在业",
            //     clientName: "叮当智慧药房(北京)有限公司第一店",
            //     clientSubType: null,
            //     clientType: null,
            //     cover: false,
            //     latitude: "39.91741",
            //     longitude: "116.41753",
            //     matchClientId: "O674ca8d2d821012",
            //     taxStatus: "正常",
            //     thirdType: 10102,
            //     tradingCompanyNum: null
            // }]
            this.totalCount = this.markerList.length
            console.log(clientPageRes)
            console.log('clientPageRes')
            console.log(clientMarkerRes)
            console.log('clientMarkerRes')

            // 未搜索到相关终端时，弹窗提示
            if (this.markerList.length === 0) {
              if (isPosition) {
                // 去除定位判断标识，避免筛选后，地图中心点不变化
                this.$refs.vMap.positionArea = {}
                this.$createDialog({
                  title: '提示',
                  type: 'confirm',
                  content: '当前定位地区您没有权限查看，是否切区域？',
                  confirmBtn: {
                    text: '是',
                    active: true,
                    disabled: false,
                    href: 'javascript:;'
                  },
                  cancelBtn: {
                    text: '否',
                    active: false,
                    disabled: false,
                    href: 'javascript:;'
                  },
                  onConfirm: () => {
                    // 显示地区选择
                    this.$nextTick(() => {
                      this.$refs.areaPicker.pickerHandle()
                    })
                  }
                }).show()
              } else {
                this.$createDialog({
                  title: '提示',
                  type: 'alert',
                  content: '未检索到相关结果！'
                }).show()
              }
            }
            pageItems.map((item, index) => {
              const dataIndex =
                (this.filterParams.page - 1) * this.filterParams.limit + index
              const lbsClientMapResp = scaClientMapRespList[dataIndex]
              const {
                longitude,
                latitude,
                businessStatus,
                taxStatus,
                thirdTypeName
              } = lbsClientMapResp
              item.longitude = longitude
              item.latitude = latitude
              item.dataIndex = dataIndex
              item.businessStatus = businessStatus
              item.taxStatus = taxStatus
              item.thirdTypeName = thirdTypeName
              return item
            })

            this.clientPageList = pageItems
            this.curClientDetails = {}
            // 滚动回归到初始位置
            this.listScrollY = 0
            this.$nextTick(() => {
              // 设置滚动点
              const _this = this
              setTimeout(function () {
                _this.$refs.scroll.scrollTo(0, _this.listScrollY)
              }, 300)
            })
            // 计算高度与初始位置
            this.countHeight()
          }
          this.loading = false
        })
        .catch(() => {
          if (isPosition) {
            // 去除定位判断标识，避免筛选后，地图中心点不变化
            this.$refs.vMap.positionArea = {}
            this.$createDialog({
              title: '提示',
              type: 'confirm',
              content: '当前定位地区您没有权限查看，是否切区域？',
              confirmBtn: {
                text: '是',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              cancelBtn: {
                text: '否',
                active: false,
                disabled: false,
                href: 'javascript:;'
              },
              onConfirm: () => {
                // 显示地区选择
                this.$nextTick(() => {
                  this.$refs.areaPicker.pickerHandle()
                })
              }
            }).show()
          } else {
            this.$createDialog({
              title: '提示',
              type: 'alert',
              content: '未检索到相关结果！'
            }).show()
          }
          this.loading = false
          // 去除定位判断标识，避免筛选后，地图中心点不变化
          this.$refs.vMap.positionArea = {}
        })
    },
    // 分页拉取获取数据
    pagingHandle () {
      this.filterParams.page = this.filterParams.page + 1
      asyncSearchClientPage(this.filterParams)
        .then((res) => {
          if (res.code === 1) {
            console.log()
            const pageItems = res.data.items || []
            pageItems.map((item, index) => {
              const dataIndex =
                (this.filterParams.page - 1) * this.filterParams.limit + index
              const lbsClientMapResp = this.markerList[dataIndex]
              const { longitude, latitude, businessStatus, taxStatus } =
                lbsClientMapResp
              item.longitude = longitude
              item.latitude = latitude
              item.dataIndex = dataIndex
              item.businessStatus = businessStatus
              item.taxStatus = taxStatus
              return item
            })
            this.clientPageList = this.clientPageList.concat(pageItems || [])
            // 终止上拉加载更多
            if (
              this.filterParams.page * this.filterParams.limit >=
              this.totalCount
            ) {
              this.$refs.scroll && this.$refs.scroll.forceUpdate()
            }
            if (pageItems.length === 0) {
              this.$createToastNew({
                txt: '获取分页数据异常'
              }).show()
            }
          } else {
            this.$createToastNew({
              txt: res.data.reason || ''
            }).show()
          }
          // 避免一次加载两页
          this.loading = false
          const _this = this
          setTimeout(function () {
            _this.paging = false
          }, 300)
        })
        .catch((err) => {
          // 避免一次加载两页
          this.loading = false
          const _this = this
          setTimeout(function () {
            _this.paging = false
          }, 300)
          console.log(err)
        })
    },
    // 终端名称输入筛选
    clientFilterHandle (name) {
      // 重置除地址外的其他参数
      // this.resetData();
      this.curClientName = name
      this.changeSearchParams({
        clientName: name
      })
      // 上报操作日志
      this.pushUserLog('搜索终端名称')
    },
    // 地区选择后处理事件
    areaPickerHandle (areaObj) {
      // 行政区域查询
      this.$refs.vMap.aMapDistrictSearch(areaObj)
      // 上报操作日志
      this.pushUserLog('地区选择-确定')
    },
    // 获取到已选地区中心坐标处理事件
    getDistrictCenterHandle (params) {
      // 触发搜索
      this.changeSearchParams(params)
    },
    // 筛选后触发事件
    filterHandle (params) {
      this.changeSearchParams(params)
      // 上报操作日志
      this.pushUserLog('筛选提交浮层-确定')
    },
    // 定位后处理事件
    positionHandle (positionArea) {
      console.log('定位')
      // 重置筛选条件
      // this.resetData();
      // this.curClientName = '';
      // this.filterParams.clientName = '';
      const positionArea1 = {
        centerLatitude: positionArea.lat,
        centerLongitude: positionArea.lng,
        cityCode: 'D' + positionArea.cityCode,
        districtCode: 'D' + positionArea.districtCode,
        lat: positionArea.lat,
        lng: positionArea.lng,
        provinceCode: 'D' + positionArea.provinceCode
      }
      // 触发搜索
      this.changeSearchParams(positionArea1, true)
      // 更新地区默认值
      this.$nextTick(() => {
        // 设置地区为定位地址
        this.$refs.areaPicker.setDefaultArea(positionArea)
      })
      // 上报操作日志
      this.pushUserLog('定位-成功')
    },
    // 定位且获取具体省市区信息后，显示
    positionAreaHandle (area) {
      if (area.provinceName === '北京市') {
        area.cityName = '北京城区'
      }
      if (area.provinceName === '上海市') {
        area.cityName = '上海城区'
      }
      if (area.provinceName === '天津市') {
        area.cityName = '天津城区'
      }
      if (area.provinceName === '重庆市') {
        area.cityName = '重庆城区'
      }
      this.defaultAreaName = area
    },
    // 定位后获取当前我的位置坐标信息，用于导航
    getMyPositionHandle (arr) {
      this.myPositionCenter = arr || ''
    },
    // 更改params值,触发搜索
    changeSearchParams (data, isPosition = false) {
      console.log('搜索')
      // isPosition 是否是定位触发
      if (this.loading) {
        return false
      }
      this.filterParams.page = 1
      this.filterParams = Object.assign(this.filterParams, data || {})
      console.log(data)
      console.log('filterParams')
      console.log(this.filterParams)
      console.log('isposition')
      console.log(isPosition)
      // 触发搜索
      this.searchClient(isPosition)
    },
    // 点击终端获取详细信息事件
    viewDetails (client, index) {
      // 正在滚动时 不触发
      if (this.touchObj.isScrolling) {
        this.touchObj.isScrolling = false
        return false
      }
      // 控制地图点活跃显示
      const pointData = {
        data: client,
        index: index
      }
      console.log('.....点击的终端.....')
      console.log(client)
      this.$refs.vMap.setActivePoint(pointData, true)
    },
    hideDetails () {
      this.curClientDetails = {}
      this.$refs.vMap.curActivePoint = {}
    },
    // 获取具体终端的详细信息 isList 是否是点击列表上的终端触发
    getClientDetails (client, isList) {
      // 显示详细信息栏目
      this.curClientDetails = client
      this.curClientDetails.clientAddress = client.address
      this.curClientDetails.phone = client.phone
      // 接口已经删除
      // asyncGetClientInfo(client.matchClientId).then(res=>{
      //     if(res.code === 1){
      //         console.log('详细数据', res)
      //         console.log('详细数据client', client)
      //         this.curClientDetails = client;
      //         this.curClientDetails.clientAddress = res.data.address;
      //         this.curClientDetails.phone = res.data.phone || res.data.phoneMore || '';
      //     }else{
      //         this.curClientDetails = {};
      //     }
      //     this.loading = false;
      // }).catch(err=>{
      //     this.curClientDetails = {};
      //     this.loading = false;
      // });
      // 上报操作日志
      this.pushUserLog(isList ? '点击列表上终端' : '点击地图上终端点')
    },
    // 显示导航操作列表
    showActionSheet (pointData) {
      const isWX = isWeiXin()
      if (isWX) {
        // 已获取定位时
        if (this.myPositionCenter) {
          this.$refs.mapDriving.show()
        } else {
          // 提示选择地区
          this.$createDialog({
            title: '提示',
            type: 'alert',
            content: '请先获取您的位置再进行路线导航！'
          }).show()
        }
        return false
      }
      this.$createActionSheet({
        data: [
          { content: '高德地图' },
          { content: '腾讯地图' },
          { content: '百度地图' }
        ],
        onSelect: (item, index) => {
          // 打开地图导航
          if (this.$store.state.UserAgent === 'ios') {
            if (index === 0) {
              // 高德地图时
              window.open(
                `iosamap://path?sourceApplication=applicationName&sid=BGVIS1&slat=39.92848272&slon=116.39560823&sname=我的位置&did=BGVIS2&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dname=${pointData.clientName}&dev=0&t=0`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `baidumap://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=ios.sca.weiming`
              )
            }
          } else {
            if (index === 0) {
              // 高德地图时
              window.open(
                `amapuri://route/plan/?sourceApplication=amap&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dev=1&t=0&dname=${pointData.clientName}`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `bdapp://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=andr.sca.weiming`
              )
            }
          }
        }
      }).show()
      // 上报操作日志
      this.pushUserLog('开始导航')
    },
    goresetPwd () {
      this.$router.push({ name: 'updatePassword' })
    },
    // 退出登录
    loginOutHandle () {
      // 百度统计事件追踪
      this.$store.dispatch('PushHmtTrackEvent', {
        category: '退出登录',
        action: '点击'
      })
      // 上报操作日志
      this.$store
        .dispatch('PushUserLog', {
          menu: '终端地图',
          page: '终端地图',
          operation: '退出登录'
        })
        .then(() => {
          // 接口退出登录
          asyncLoginOut()
            .then(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
            .catch(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
        })
        .catch(() => {
          /// 接口退出登录
          asyncLoginOut()
            .then(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
            .catch(() => {
              // 清除token
              this.$store.dispatch('LoginOut')
              this.$router.replace({ name: 'login' })
            })
        })
    },
    // 上拉加载
    onPullingUp () {
      if (!this.paging) {
        if (
          this.filterParams.page * this.filterParams.limit <
          this.totalCount
        ) {
          this.paging = true // 避免重复多次加载
          // 上拉加载更新数据
          this.pagingHandle()
        } else {
          this.$refs.scroll && this.$refs.scroll.forceUpdate()
        }
      }
    },
    // 子组件滚动开始时
    listScrollStart () {
      if (
        this.$refs.scroll.scroll.y < 0 &&
        this.$refs.panelScroll.scroll.y < this.touchLess - 100
      ) {
        // 禁止父级scroll滚动
        this.$refs.panelScroll.disable()
      }
    },
    // 子组件滚动事件
    scrollHandler ({ y }) {
      this.listScrollY = y
      this.touchObj.isScrolling = true
    },
    // 子组件滚动结束时
    listScrollEnd () {
      this.$refs.panelScroll.enable()
      const _this = this
      setTimeout(function () {
        _this.touchObj.isScrolling = false
      }, 300)
    },
    // 父级滚动开始时
    beforeScrollHandle () {
      // 将地图模块zIndex层级放低
      this.touchObj.isTouchMove = true
      if (this.$refs.panelScroll.scroll.y >= this.touchLess) {
        // 禁止列表scroll滚动
        this.$refs.scroll.disable()
      }
    },
    // 父级滚动事件
    parentScroll ({ y }) {
      // 当滚动到顶部时，激活子scroll的滚动
      if (-y === this.touchObj.placeholderHeight) {
        this.$refs.scroll.refresh()
        this.$refs.scroll.enable()
      } else if (y > this.touchLess) {
        // 当往下滚动超过地图区域时，给地图添加高度
        this.touchObj.curMapStyle = {
          height: this.touchObj.threshold + (y - this.touchLess) + 'px'
        }
      }
    },
    // 父级滚动滚动停止事件
    scrollEndHandle ({ y }) {
      // 判断是否到达临界点
      if (!this.touchObj.isScrollTo) {
        if (this.touchLess - y > this.touchObj.threshold / 2) {
          this.touchObj.isScrollTo = true
          // 往上滑动超过100时，让滚动到顶部
          this.$refs.panelScroll.scrollTo(
            0,
            -this.touchObj.placeholderHeight,
            400
          )
        } else if (
          this.touchLess - y > 0 &&
          this.touchLess - y <= this.touchObj.threshold / 2
        ) {
          this.touchObj.isScrollTo = true
          // 往上滑动不超过100时，让滚动回到临界点
          this.$refs.panelScroll.scrollTo(0, this.touchLess, 400)
        } else if (y - this.touchLess >= 0 && y - this.touchLess < 100) {
          this.touchObj.isScrollTo = true
          // 往上滑动不超过100时，让滚动回到临界点
          this.$refs.panelScroll.scrollTo(0, this.touchLess, 400)
        } else if (y - this.touchLess > 100) {
          // 往下控制滚动到点击查看详情
          this.touchObj.isScrollTo = true
          this.touchObj.isShowMoreTip = true
          this.$refs.panelScroll.scrollTo(0, 0, 400)
          this.$refs.panelScroll.disable()
        }
        const _this = this
        setTimeout(function () {
          _this.touchObj.isScrollTo = false
          if (_this.$refs.panelScroll.scroll.y >= _this.touchLess) {
            // 地图模块zIndex层级
            _this.touchObj.curMapStyle = {
              height:
                _this.touchObj.placeholderHeight +
                _this.$refs.panelScroll.scroll.y +
                'px'
            }
            _this.touchObj.isTouchMove = false
          }
        }, 400)
      }
    },
    // 点击查看更多处理事件
    viewMoreHandle () {
      // 地图模块zIndex层级
      this.touchObj.isTouchMove = true
      this.touchObj.isShowMoreTip = false
      this.$refs.panelScroll.enable()
      this.$refs.panelScroll.scrollTo(0, -this.touchObj.placeholderHeight, 400)
    },
    // 计算高度
    countHeight () {
      this.$nextTick(() => {
        const contH = this.$refs.content.offsetHeight
        if (this.clientPageList.length <= 3) {
          this.touchObj.threshold = Math.round(
            contH -
              this.$refs.handle.offsetHeight -
              this.$refs.listUl.offsetHeight
          )
        } else {
          this.touchObj.threshold = Math.round(562 * this.$store.state.per)
        }
        this.touchObj.curMapStyle = {
          height: this.touchObj.threshold + 'px'
        }
        // 不显示查看更多提示
        this.touchObj.isShowMoreTip = false
        // 定位到阈值
        this.$refs.panelScroll.scrollTo(0, this.touchLess)
      })
    },
    // 个人信息浮窗控制
    userPopHandle () {
      this.isShowPop = !this.isShowPop
      if (this.isShowPop) {
        // 上报操作日志
        this.pushUserLog('打开个人信息浮层')
      }
    },
    // 上报操作日志封装
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '终端地图',
        page: '终端地图',
        operation: text
      })
    },
    // 进入购进详情
    goPurchaseDetail (data) {
      this.pushUserLog('进入购进详情')
      console.log('/////////')
      console.log(this)
      this.$nextTick(() => {
        this.$router.push({
          name: 'purchaseDetail',
          query: {
            data: JSON.stringify(data),
            searchData: JSON.stringify(this.filterParams)
          }
        })
      })
    },
    // 反馈
    feedbackMessage (data) {
      this.pushUserLog('进入反馈')
      this.$router.push({
        name: 'feedbackMessage',
        query: {
          data: JSON.stringify(data)
        }
      })
    }
  },
  // eslint-disable-next-line no-dupe-keys
  beforeRouteLeave (to, from, next) {
    if (to.name === 'feedbackSuccess') {
      next(false)
    } else {
      if (to.name === 'login') {
        from.meta.keepAlive = false
        // this.$destroy()
        next() // 当我们前进的不是C时我们让B页面刷新
      } else {
        if (to.name === 'feedbackMessage' || to.name === 'purchaseDetail') {
          if (!from.meta.keepAlive) {
            from.meta.keepAlive = true
          }
          // 刷新下一页
          to.meta.isUseCache = true
          next()
        } else {
          next()
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/home/index.styl';

.cubeic-back {
  position: absolute;
  font-size: 50px;
  top: 8px;
  left: 0;
  padding: 0 10px;
  color: #4d8ee3;
}
</style>
<style scoped>
@-moz-document url-prefix() {
  .cover-btn {
    line-height: 32px;
  }
}
</style>
